// extracted by mini-css-extract-plugin
module.exports = {"def":"_type_def__2vKAM","dense":"_type_dense__1XgIq"};